import { render, staticRenderFns } from "./SweepEmailSourceConfiguration.vue?vue&type=template&id=879ea132&scoped=true&"
import script from "./SweepEmailSourceConfiguration.vue?vue&type=script&lang=ts&"
export * from "./SweepEmailSourceConfiguration.vue?vue&type=script&lang=ts&"
import style0 from "./SweepEmailSourceConfiguration.vue?vue&type=style&index=0&id=879ea132&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "879ea132",
  null
  
)

export default component.exports